import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./chatNote.module.css";
import { chatNoteTypes } from "../../utils/constants";
import { TChatNoteType } from "../../types/types";
import i18n from "../../i18n";

function ChatNote({
  name,
  text,
  type,
}: {
  name: string;
  text?: string;
  type: TChatNoteType;
}) {
  return (
    <div className={styles.note} dir={i18n.dir()}>
      {type === chatNoteTypes.isTyping ? (
        <>
          <span className={styles.note_typing}>{name}</span>
          <span className={styles.note_typing}>{t('CHAT_TYPING')}</span>
          <span className={styles.loader} />
        </>
      ) : (
        <span>{text || ""}</span>
      )}
    </div>
  );
}

export default ChatNote;
